import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ce40e7f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cinema__empty" }
const _hoisted_2 = { class: "cinema__empty-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cinema-empty-header" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "cinema__empty-title" }, " 个人片库 "),
  /*#__PURE__*/_createElementVNode("p", { class: "cinema__empty-subtitle" }, " 添加视频所在文件夹，开启海报/字幕智能匹配 ")
], -1))

import { useRouter } from 'vue-router'
import GradientButton from '../GradientButton.vue'
// import empty from '@shared/assets/img/cinema-empty.png'
// import { useCinemaStore } from '@remote/store/cinema'
// import { openCinemaSourceSetting } from '@remote/utils/dialog'
// const cinemaStore = useCinemaStore()
import { stat } from '@remote/utils/stat'
import { isLargeViewPort } from '@remote/utils/base'
import Modal from '@remote/components/modal'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const empty = 'https://oss-nas-ssl.xunlei.com/hezi/images/cinema_png_index.webp'

const router = useRouter()
function onClick () {
  stat({
    action: 'cinema_tab_click',
    data: { click_id: 'source_setting' },
  })
  const isPC = isLargeViewPort()
  if (!isPC) {
    router.push({
      name: 'scrapeSettings',
    })
  } else {
    // 刮削设置弹窗
    Modal.showScrapePathSettingModal({ mask: true })
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("img", {
        src: empty,
        class: "cinema__empty-picture"
      }),
      _createVNode(GradientButton, {
        class: "cinema__empty-button",
        text: "立即添加",
        onClick: onClick
      })
    ])
  ]))
}
}

})